const location = window.location.origin;

export const serverUrl = location === "http://localhost:3000" ?
process.env.REACT_APP_DEV_SERVER_URL :
process.env.REACT_APP_SERVER_URL; 